'use strict';

(function () {
  'use strict';

  angular.module('msTracker').controller('TrackerChartsCtrl', TrackerChartsCtrl);

  TrackerChartsCtrl.$inject = ['$log', 'NotifyingSvc', 'moodTrackerSvc'];

  /* @ngInject */
  function TrackerChartsCtrl($log, NotifyingSvc, moodTrackerSvc) {
    var vm = this;
    vm.title = 'TrackerChartsCtrl';
    vm.colors = ['blue', 'yellow', 'purple', 'green', 'deeporange', 'pink'];
    vm.defaultStartData = moment();
    vm.$onInit = activate;

    ////////////////

    function activate() {
      $log.debug(vm.title + ' activate');
      // initiate default queries
      updateTrackedMoods();
      NotifyingSvc.subscribe(NotifyingSvc.EVENTS.REFRESH_TRACKER, function () {
        return updateTrackedMoods();
      });
    }

    function updateTrackedMoods() {
      moodTrackerSvc.getTrackedMoods().then(function (data) {
        return vm.trackedMoods = data;
      });
    }
  }
})();